module.exports = {
  title: 'Rajendra Pareek | Full Stack Developer',
  description:
    'Full stack developer in Jodhpur, India specializing in C#, React, and SQL Server, delivering high-performance web applications and integrations.',
  keywords:
    'Rajendra Pareek, Full Stack Developer, C#, React.js, SQL Server, JavaScript, APIs, Jodhpur, Rajasthan, India, Portfolio',
  siteUrl: 'https://www.rajendrapareek.com'
};
